module.exports = __webpack_public_path__ + "static/media/cliente-pantanal-agricola.50f959c8.webp";